import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';
import { environment } from 'src/environments/environment';
import { UserActivityRequest, UserActivityResponse, ActivitySearch, ActivitySummary } from '../model/user-activity';

@Injectable({
  providedIn: 'root'
})
export class UserActivityService {

  constructor(
    private http: HttpClient
  ) { }

  logEvent(eventName: string, details: any) {
    console.log(`Event: ${eventName}`, details);
    // You can also send these logs to a backend service or an analytics platform
  }


  userActivityEvents(taskConfgsReq: UserActivityRequest): Observable<UserActivityResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID')
    });
    const options = { headers};
    return this.http.post<any>(environment.apiUserActivityURL + '/events', JSON.stringify(taskConfgsReq), options);
  }

  getActivitySummary(activitySearch: ActivitySearch): Observable<ActivitySummary> {
    let params = new HttpParams();
    params = params.append('pagelimit', '10');
    if (activitySearch.containerNumber) {
      params = params.append('containerNumber', activitySearch.containerNumber);
    }
    if (activitySearch.pageNumber) {
      params = params.append('page', activitySearch.pageNumber);
    }else{
      params = params.append('page', '0');
    }
    if (activitySearch.asnNumber) {
      params = params.append('asnNumber', activitySearch.asnNumber);
    }
    if (activitySearch.itemCode) {
      params = params.append('itemCode', activitySearch.itemCode);
    }
    if (activitySearch.serialNumber) {
      params = params.append('serialNumber', activitySearch.serialNumber);
    }
    if (activitySearch.userName) {
      params = params.append('userName', activitySearch.userName);
    }
    if (activitySearch.transactionType) {
      params = params.append('transactionType', activitySearch.transactionType);
    }
    if (activitySearch.status) {
      params = params.append('status', activitySearch.status);
    }
    if (activitySearch.location) {
      params = params.append('location', activitySearch.location);
    }
    if (activitySearch.palletNumber) {
      params = params.append('palletNumber', activitySearch.palletNumber);
    }
    if (activitySearch.transactionStartDate) {
      params = params.append('transactionStartDate', activitySearch.transactionStartDate);
    }
    if (activitySearch.transactionEndDate) {
      params = params.append('transactionEndDate', activitySearch.transactionEndDate);
    }
    console.log(params);
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        'Access-Control-Allow-Origin': '*'
      },
      params
    };

    return this.http.get<ActivitySummary>(environment.apiUserActivityURL +'/populate', httpOptions);
}
}